module.exports = __webpack_public_path__ + "img/conimg2-06.7407db7d.png";